export default Object.freeze({
  0: 'execution',
  1: 'approved',
  2: 'rejected',
  3: 'canceled',
  4: 'voided',
  5: 'error',
  6: 'execution',
});
